<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          text
          rounded
          class="ma-3"
          color="green darken-3"
          >ADD ATTORNEY</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
      >
        <v-card-title>
          <span>ADD </span><span class="red--text">ATTORNEY</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddAttorney" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <div>Select From Firm</div>
              <v-select
                label="search attorneys"
                outlined
                rounded
                clearable
                dark
                autofocus
                class="ma-2"
                append-icon="mdi-magnify"
                :items="firm.attorneys"
                item-text="fullName"
                v-model="existingAttorney"
                return-object
                color="#2E5473"
                dense
                filled
              ></v-select>
              <div>Add a New attorney</div>
              <div class="ma-2 mt-2">
                <v-text-field
                  @change="clearExistingAttorneys"
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  v-model="name"
                  multiple
                  label="ENTER ATTORNEY NAME (required)"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  v-model="barNumber"
                  multiple
                  label="ENTER ATTORNEY BAR NUMBER"
                  color="#2E5473"
                  dense
                  filled
                  @change="clearExistingAttorneys"
                ></v-text-field>
              </div>
              <!-- <v-card>
                <ol class="ma-auto">
                  <li v-for="(attorney, index) in attorneys" :key="index">
                    <v-layout>
                      <div class="ma-auto">{{ attorney.name }}, SBN: {{attorney.barNumber}}</div>
                      <v-btn small text rounded @click="removeAttorney(index)">
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-layout>
                  </li>
                </ol>
              </v-card>-->
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >ADD</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 * this component allows the user to add an attorney to the matter
 * this list of attorneys is shown on the documents that are created by the user
 * the user is given a set of options to choose (taken from the "firm" collection in the database)
 * if the attorney they are looking for is not in the list, they are allowed to add a new name and bar numnber
 * that attorney is then added to the matter as well as to the firm document so that it is part of the list
 * for later matters
 *
 * //todo: change this to allow for attorneys that are not part of the firm (associated counsel)
 * or create an "AddAssociatedAttorney" component that will add an associated attorney to the matter
 * or allow the user to add a service list item to the pleadings as associated councel.
 */
import * as firebase from "firebase";
export default {
  props: ["matter"],
  data() {
    return {
      name: null,
      barNumber: null,
      // attorneys: [],
      dialog: false,
      existingAttorney: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // matter() {
    //   return this.$store.getters.;
    // },
    formIsValid() {
      return this.name !== null || this.existingAttorney !== null;
    },
    firm() {
      return this.$store.getters.firm;
    }
  },
  watch: {
    name(val) {
      if (val !== null && val !== undefined) {
        this.existingAttorney = null;
      }
    },
    barNumber(val) {
      if (val !== null && val !== undefined) {
        this.existingAttorney = null;
      }
    },
    existingAttorney(val) {
      if (val !== null && val !== undefined) {
        this.name = null;
        this.barNumber = null;
      }
    }
  },
  methods: {
    // onFilePicked() {
    //   if (event.target.files) {
    //     const fileList = Array.from(event.target.files);
    //     fileList.forEach(file => {
    //       this.initialDocs.push(file);
    //     });
    //   }
    // },

    // removeAttorney(index) {
    //   this.attorneys.splice(index, 1);
    // },
    clearExistingAttorneys() {
      this.existingAttorney = null;
    },
    clearNameAndBar() {
      this.name = null;
      this.barNumber = null;
      this.dialog = false;
    },
    onAddAttorney() {
      if (this.formIsValid) {
        if (!this.existingAttorney) {
          let attorney = {
            name: this.name,
            barNumber: this.barNumber,
            fullName: `${this.name}, SBN ${this.barNumber}`
          };
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              attorneys: firebase.firestore.FieldValue.arrayUnion(attorney)
            });
          this.name = null;
          this.barNumber = null;
          this.dialog = false;
          firebase
            .firestore()
            .collection("firms")
            .doc(this.user.firmSlug)
            .update({
              attorneys: firebase.firestore.FieldValue.arrayUnion(attorney)
            });
        } else if (this.existingAttorney) {
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              attorneys: firebase.firestore.FieldValue.arrayUnion(
                this.existingAttorney
              )
            });
          this.existingAttorney = null;
          this.dialog = false;
        }
      }
    },
    cancelDialog() {
      this.existingAttorney = null;

      this.name = null;
      this.barNumber = null;

      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
